$(function (joih, $, undefined) {
	//-----------------------------------------
	// Namespaced Functions
	//-----------------------------------------
    joih.setDrawerTop = function() {
        var announcementBar = $(".AnnouncementBar");
        if (announcementBar.length)
        {
            var announcementBarHeight = announcementBar.height();
            var mainContentTopOffset = $("#MainContent").scrollTop();
            var headerHeight = $("header").height();
            var scrollTop = $(window).scrollTop();
            var elementOffset = $("#MainContent").offset().top;
            var distance = (elementOffset - scrollTop);
            //console.log((headerHeight / 2) + distance);
    
            announcementBarHeight = $(document).scrollTop() > announcementBarHeight ? 0 : announcementBarHeight;
            
            $(".DrawerContent").css("padding-top", (headerHeight + distance) + "px");
        }
    }
    //-----------------------------------------
	// On Load/Refresh
	//-----------------------------------------
    $(document).ready(function() {
   		var currentTemplate = $("#CurrentTemplate").val();

        joih.setDrawerTop();

        $(".Accordion").each(function(){
    		$(this).find("li").first().find(".AccordionHeader").find(".AccordionControl").html("[ - ]");
        });

        if ($("body").attr("id") == "membership")
        {
            //$(".header__wrapper").attr("data-header-transparent", "true");
        }

       	if (currentTemplate == "cart")
        {
            //find the hidden input that holds the cart attribute on the cart page and get its value
            var agreedToTermsAttribute = $("input[name='attributes[agreedToTerms]']");
            //get the related checkbox
            var agreementCheckbox = $(".ChkAgreeToTerms");
            //console.log(agreedToTermsAttribute.val());
          
            //if the hidden input is present then set checkbox to its value.
            agreementCheckbox.prop("checked", agreedToTermsAttribute.length && agreedToTermsAttribute.val().toLowerCase() == "yes" ? true : false);

            //finally, disable/enable the checkout based on whether or not the checkbox is checked
            $(".CartCheckoutButton").attr("disabled", !agreementCheckbox.prop("checked"));
        }
    });

  	//-----------------------------------------
	// Events/Watchers
	//-----------------------------------------
	$(document).on("click", ".AccordionHeader", function (e) {
      	e.preventDefault();
      	e.stopPropagation();

      	//$(this).closest(".Accordion").each(function() {
        //	$(this).find(".AccordionBody").slideUp(1000);
		//	$(this).find(".AccordionControl").text("[+]");
      	//});

		var accordionControl = $(this).find(".AccordionControl");
		var accordionBody = $(this).closest("li").find(".AccordionBody");

		if (accordionBody.is(":visible")) {
			accordionControl.html("[ + ]");
			accordionBody.slideUp(1000);
		}
		else {
			accordionControl.html("[ - ]");
			accordionBody.slideDown(1000);
		}
	});
      
	$(document).on("click", ".ExtendedControls", function() {
		var product = $(this).attr("data-product");
		var section = $("#Extended_" + product);
      	var controlText = $(this).find(".ControlText");
      	var controlImage = $(this).find(".ControlImage");

        //console.log(product);
      	
      	if (section.is(":visible")) {
            console.log("close");
          	controlText.html("More Info");
            controlImage.html("[ + ]");

  			section.slideUp(1000);
        }
        else {
            console.log("open");
          	controlText.html("Less Info");
            controlImage.html("[ - ]");

         	section.slideDown(1000);
        }
	});

    $(document).on("click", ".ChkAgreeToTerms", function() {
        var checkedValue = !this.checked ? "No" : "Yes";
        $(".CartCheckoutButton").attr("disabled", !this.checked);
        $.post("/cart/update.js", {"attributes": {"agreedToTerms": checkedValue}}, null, "json");
    });

  	$(document).on("click", ".CoveredVideoSection ul", function() {
        var coveredVideoPreview = $(this).find(".CoveredVideoPreview");
      
        if (coveredVideoPreview.is(":visible"))
        {
        	coveredVideoPreview.hide();
        	$(this).find(".CoveredVideo").show();
    		$(this).find(".CoveredVideo iframe")[0].src += "&autoplay=1";
        }

        return false;
    });
  
    $(window).on('resize scroll', function(){
        joih.setDrawerTop();
    });
} (window.joih = window.joih || {}, jQuery));
